import React, { memo } from 'react'
import * as CountryFlags from 'country-flag-icons/react/3x2'
import { Box, Typography } from '@mui/material'

// Station code (numeric) to country ISO code mapping
// Based on the complete station table with ISO country codes
const STATION_COUNTRY_MAP = {
  '1': 'CI',
  '2': 'NG',
  '3': 'AE',
  '5': 'ET',
  '6': 'DZ',
  '7': 'KZ',
  '8': 'TR',
  '9': 'BE',
  '10': 'GR',
  '11': 'ML',
  '12': 'TH',
  '15': 'IE',
  '16': 'RS',
  '17': 'DE',
  '18': 'DE',
  '19': 'CH',
  '20': 'HU',
  '21': 'RO',
  '23': 'CO',
  '24': 'IN',
  '26': 'BR',
  '27': 'SK',
  '28': 'BE',
  '30': 'VN',
  '32': 'AR',
  '33': 'CH',
  '34': 'PH',
  '35': 'AU',
  '36': 'VE',
  '37': 'US',
  '38': 'MZ',
  '39': 'LK',
  '40': 'BJ',
  '41': 'ZW',
  '43': 'SN',
  '44': 'BG',
  '46': 'TZ',
  '47': 'MX',
  '48': 'CU',
  '49': 'SE',
  '50': 'BD',
  '51': 'FR',
  '52': 'FI',
  '54': 'IT',
  '55': 'AE',
  '56': 'AU',
  '57': 'NL',
  '58': 'CN',
  '59': 'TW',
  '61': 'IR',
  '63': 'IL',
  '64': 'JP',
  '66': 'RU',
  '67': 'DE',
  '68': 'PK',
  '69': 'CA',
  '70': 'LY',
  '71': 'TR',
  '72': 'TN',
  '73': 'OM',
  '74': 'CA',
  '75': 'ID',
  '76': 'KE',
  '78': 'IN',
  '80': 'ZA',
  '81': 'US',
  '82': 'PL',
  '83': 'EG',
  '85': 'NZ',
  '86': 'UG',
  '87': 'AT',
  '88': 'NO',
  '90': 'CW',
  '92': 'CA',
  '93': 'SD',
  '95': 'UA',
  '96': 'BF',
  '97': 'HR',
  '100': 'SR',
  '101': 'CD',
  '102': 'FR',
  '104': 'DK',
  '105': 'CN',
  '107': 'RU',
  '108': 'KW',
  '109': 'NG',
  '110': 'TT',
  '112': 'ZA',
  '114': 'MA',
  '115': 'SA',
  '116': 'IT',
  '118': 'US',
  '119': 'CR',
  '120': 'CL',
  '121': 'DO',
  '122': 'BR',
  '123': 'KR',
  '124': 'CN',
  '125': 'SG',
  '127': 'PE',
  '128': 'PT',
  '129': 'GB',
  '131': 'AO',
  '133': 'LU',
  '134': 'ES',
  '136': 'RW',
  '137': 'VN',
  '138': 'JO',
  '139': 'BA',
  '140': 'LB',
  '141': 'LV',
  '142': 'CN',
  '143': 'GT',
  '144': 'PS',
  '145': 'AL',
  '146': 'MK',
  '147': 'JP',
  '148': 'BR',
  '149': 'US',
  '150': 'AZ',
  '151': 'XK',
  '152': 'SI',
  '154': 'LT',
  '155': 'EE',
  '157': 'GE',
  '158': 'US',
  '159': 'AF',
  '160': 'MT',
  '161': 'CY',
  '163': 'IQ',
  '164': 'QA',
  '165': 'SS',
  '167': 'KZ',
  '168': 'BI',
  '171': 'PA',
  '172': 'IQ',
  '173': 'CN',
  '177': 'MM',
  '179': 'CD',
  '181': 'BY',
  '182': 'MD',
  '183': 'IN',
  '184': 'NE',
  '190': 'TD',
  '191': 'US',
  '192': 'GH',
  '193': 'ET',
  '194': 'BE',
  '195': 'BE',
  '196': 'BE',
  '197': 'BE',
  '198': 'CH',
  '199': 'CH',
  '200': 'CH',
  '201': 'US',
  '202': 'US',
  '203': 'US',
  '204': 'US',
  '205': 'US',
  '206': 'US',
  '207': 'AT',
  '208': 'AT',
  '209': 'FR',
  '210': 'MY',
  '212': 'CZ',
  '213': 'IT',
  '214': 'IT',
  '215': 'GB',
  '216': 'LU',
  '217': 'IQ',
  '218': 'LB',
  '219': 'BE',
  '220': 'NL',
  '221': 'CH',
  '222': 'CD',
  '223': 'UA',
  '224': 'CD',
  '225': 'KE',
  '226': 'XK',
  '227': 'MK',
  '228': 'GE',
  '229': 'LY',
  '230': 'AF',
  '231': 'PL',
  '232': 'IQ',
  '234': 'IL',
  '235': 'PS',
  '236': 'AZ',
  '238': 'NE',
  '249': 'RS',
  '250': 'IT',
  '251': 'TN',
  '252': 'AM',
  '253': 'SO',
  '254': 'SS',
  '255': 'DE',
  '256': 'ES',
  '257': 'AL',
  '258': 'AM',
  '259': 'MD',
  '260': 'NE',
  '261': 'RU',
  '262': 'AT',
  '263': 'UZ',
  '264': 'KG',
  '265': 'HU',
  '266': 'NE',
  '268': 'BA',
  '269': 'KZ',
  '270': 'IT',
  '271': 'AU',
  '272': 'ME',
  '273': 'TR',
  '274': 'US',
  '275': 'SN',
  '276': 'ES',
  '277': 'GR',
  '278': 'MN',
  '279': 'AW',
  '900': 'AW',
  '901': 'BQ',
  '902': 'CW',
  '903': 'BQ',
  '904': 'BQ',
  '905': 'SX',
}

const UnknownFlag = () => {
  return (
    <svg width="30" height="20" xmlns="http://www.w3.org/2000/svg">
      <rect x="0" y="0" width="30" height="20" fill="#808080" />
    </svg>
  )
}

export const Country = ({ stationCode, label, showLabel = true }) => {
  // Get country code from station code - trim any whitespace from the ISO code
  const countryCode = STATION_COUNTRY_MAP[stationCode]?.trim() || null

  // Get the flag component - need to handle the import properly
  let CountryFlagComponent = UnknownFlag

  if (countryCode) {
    const flagKey = countryCode.toUpperCase()
    if (CountryFlags[flagKey]) {
      CountryFlagComponent = CountryFlags[flagKey]
    }
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        '& > svg': {
          mr: 0.5,
          flexShrink: 0,
          width: '24px',
          maxHeight: '16px',
        },
      }}
    >
      <CountryFlagComponent />
      {showLabel && (
        <Typography
          component="span"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            ml: 1,
            fontSize: 'inherit',
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit'
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  )
}

export default memo(Country)
